import toast from "react-hot-toast";
import { log, supabase } from ".";
import { esCotizable } from "../constants/estadosEdificio";
import { EDIFICIOS_EXCLUIDOS } from "../constants/permisos";

// Estados visibles en el listado B2B público = esCotizable (OPERATIVO + instalando).
// Variante de getEdificiosOperativos para el listado B2B público.
// Misma query/patrón (filtra país a nivel query, estado en JS), pero amplía
// los estados visibles. NO reemplaza a getEdificiosOperativos (cero impacto
// en sus consumidores). Devuelve el campo `estado` para segmentar en UI.
export const getEdificiosListadoPublico = async ({ pais }) => {
  try {
    const data = await supabase.select("edificios", {
      filters: {
        pais,
      },
      orderBy: "pantallas",
      ascending: false,
    });

    const filteredData = data.filter(
      (edificio) => esCotizable(edificio.estado) && !edificio.eliminada && !EDIFICIOS_EXCLUIDOS.includes(edificio.id)
    );

    if (filteredData.length === 0) {
      toast.error("No hay edificios cargados en la base de datos");
      throw new Error("No data found");
    }

    return filteredData;
  } catch (error) {
    log.error("getEdificiosListadoPublico", error);
    throw error;
  }
};
